import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import CellTooltiped from './CellTooltiped';
import Cell from '../Body/Cell';
import type { TableCellValue } from '../utils/types';

type CellLinkedProps = {
    value?: TableCellValue;
    link?: string;
    maxLength?: number;
};

const isCellLinkedProps = (
    props: CellLinkedProps | TableCellValue
): props is CellLinkedProps =>
    typeof props === 'object' && props !== null && ('value' in props || 'link' in props);

function CellLinked(props: CellLinkedProps | TableCellValue = { value: null }) {
    const linkedProps = isCellLinkedProps(props) ? props : null;
    const value = linkedProps ? linkedProps.value : props;
    const isLink = !!linkedProps?.value && !!linkedProps.link;

    if (!isLink) return Cell(value);

    const stringValue = String(value ?? '');
    const maxLength = linkedProps?.maxLength ?? stringValue.length;
    const trimmedValue = useMemo(() => (
        stringValue.length > maxLength
            ? `${stringValue.substring(0, maxLength)}...`
            : stringValue
    ),
    [stringValue, maxLength]);

    return (
        linkedProps?.link
            ? (
                <Link to={linkedProps.link} className="table-cell_linked">
                    <CellTooltiped {...linkedProps} />
                </Link>
            )
            : (
                <span className="table-cell">{trimmedValue}</span>
            )
    );
}


export default CellLinked;
